.calendario {
  width: 280px;
  padding: 14px;
}

.cabecalho {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) 34px;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.mesAno {
  justify-self: center;
  min-width: 104px;
  height: 28px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: color-mix(in srgb, var(--accent-main) 14%, transparent);
  color: var(--accent-main);
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.mesAno:hover {
  background: color-mix(in srgb, var(--accent-main) 18%, transparent);
}

.nav {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 0;
  background: transparent;
  color: var(--muted);
  font: inherit;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.nav:hover {
  color: var(--accent-main);
  background: color-mix(in srgb, var(--accent-main) 10%, transparent);
}

.semana,
.grade {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 3px;
}

.semana {
  margin-bottom: 6px;
}

.semana span {
  text-align: center;
  font-size: 11.5px;
  font-weight: 700;
  color: var(--text-negrito);
  padding: 4px 0;
}

.dia {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  justify-self: center;
}

.dia:hover {
  background: color-mix(in srgb, var(--accent-main) 10%, transparent);
  color: var(--accent-main);
}

.diaFora {
  color: color-mix(in srgb, var(--muted) 48%, transparent);
}

.hoje {
  border-color: color-mix(in srgb, var(--accent-main) 68%, transparent);
  color: var(--accent-main);
}

.selecionado {
  border-color: var(--accent-main);
  color: var(--accent-main);
  font-weight: 700;
}

.selecionado:hover {
  background: color-mix(in srgb, var(--accent-main) 12%, transparent);
}

.feriado {
  border: 2px dotted var(--accent-main);
  color: var(--accent-main);
  font-weight: 700;
  box-sizing: border-box;
}

.feriado:hover {
  background: color-mix(in srgb, var(--accent-main) 15%, transparent);
}

.rodape {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.hojeBtn {
  border: none;
  background: transparent;
  color: var(--accent-main);
  font: inherit;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  padding: 5px 8px;
  border-radius: 6px;
}

.hojeBtn:hover {
  background: color-mix(in srgb, var(--accent-main) 12%, transparent);
}

.gradeMesAno {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 8px 0 2px;
}

.itemMesAno {
  height: 38px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}

.itemMesAno:hover {
  background: color-mix(in srgb, var(--accent-main) 10%, transparent);
  color: var(--accent-main);
}

.itemMesAnoAtivo {
  border-color: color-mix(in srgb, var(--accent-main) 34%, transparent);
  background: color-mix(in srgb, var(--accent-main) 14%, transparent);
  color: var(--accent-main);
  font-weight: 700;
}
